module.exports = __webpack_public_path__ + "static/media/grey-pin.caac3ab7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/grey-pin.svg
// module id = 1017
// module chunks = 0